type ClockIconProps = {
  color?: string;
};

const ClockIcon: React.FC<ClockIconProps> = ({ color = "#58348E" }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 4C14.1217 4 16.1566 4.84285 17.6569 6.34315C19.1571 7.84344 20 9.87827 20 12C20 14.1217 19.1571 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20C9.87827 20 7.84344 19.1571 6.34315 17.6569C4.84285 16.1566 4 14.1217 4 12C4 9.87827 4.84285 7.84344 6.34315 6.34315C7.84344 4.84285 9.87827 4 12 4ZM11.25 7.75V12C11.25 12.25 11.375 12.4844 11.5844 12.625L14.5844 14.625C14.9281 14.8562 15.3938 14.7625 15.625 14.4156C15.8562 14.0687 15.7625 13.6062 15.4156 13.375L12.75 11.6V7.75C12.75 7.33437 12.4156 7 12 7C11.5844 7 11.25 7.33437 11.25 7.75Z"
      fill={color}
    />
  </svg>
);

export default ClockIcon;
